export default "__VITE_PUBLIC_ASSET__e8a39df7__"